import { useMutation } from '@tanstack/react-query'
import { ExtendableMutationOptions } from 'shared/api/api.types'

import { forgeApi } from '../..'
import { UnshareArtifactOrgsRequest } from './unshareArtifactOrgs.types'

export const unshareArtifactOrgs = async ({
  publicId,
  orgIds
}: UnshareArtifactOrgsRequest): Promise<void> => {
  await forgeApi.delete(
    `/api/v1/artifacts/${encodeURIComponent(publicId)}/shares`,
    { data: { orgs: orgIds.map(id => ({ id })) } }
  )
}

export const useUnshareArtifactOrgsMutation = (
  options?: ExtendableMutationOptions<void, UnshareArtifactOrgsRequest>
) =>
  useMutation({
    mutationFn: unshareArtifactOrgs,
    ...options
  })
